import { AddJawabanQuestionnairePayload } from "../../../../models/Questionnaire";
import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import { questionnaireKey } from "../../queries/Questionnaire/useFetchQuestionnaire";
import { checkProfileKey } from "../../queries/User/useFetchCheckProfile";
import getQueryClient from "../../queryClient";
import ApiClient from "../../../apiClient";

export async function addJawabanQuestionnaire(
  data: AddJawabanQuestionnairePayload[]
) {
  const res = await ApiClient.post(`/AddJawabanQuestionnaire`, data);
  return res.data;
}

export const useAddJawabanQuestionnaire = mutationWrapper(
  addJawabanQuestionnaire,
  {
    onSuccess: () => {
      getQueryClient().invalidateQueries(questionnaireKey);
      getQueryClient().invalidateQueries(checkProfileKey);
    },
  }
);
